// extracted by mini-css-extract-plugin
export default {"root":"_3IzWY","image":"_18BJW","large":"oy_5T","medium":"_2Fxmn","small":"_32J43"};